export class OverlayTag {
  public id: string = '';
  public tag: string = '';
  public overlayType: number = 0;
  public color: string = '#FFFFFF';
  public title: string = '';
  public name: string = '';
}
